import { render, staticRenderFns } from "./customerBig.vue?vue&type=template&id=7fa95b5e"
import script from "./customerBig.vue?vue&type=script&lang=js"
export * from "./customerBig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports